import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';

// import { AuthGuard } from './services/authguard/AuthGuard.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { AgGridModule } from 'ag-grid-angular';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
} from 'ng-pick-datetime';
// User Defined
//Place All Modules here
import { AppRoutingModule } from './app-routing.module';
// Place All Components here
import { AppComponent } from './app.component';
import { P404Component } from './views/error/404.component';
// Place All Services Here
import { TranslateService } from './services/translateservice/translate.service';
import { BusinessServices } from './services/singleton/business-services';
import { SmartAppUtilities } from './models/common/getjsonfrom-controls-service-model';
import { ImplementOperationToolbar } from './services/btnservice/toptoolbar-implementation';
import { ConfirmationDialogServices } from './shared/confirmation-dialog/confirmation-dialog.service';
import { FinanceBusinessService } from './services/finance/finance-business.service';

// Place All Repositories here
import { CommonRepository } from './repositories/common-repository/CommonRepository';
import { LoginRepository } from './repositories/login-repository/LoginRepository';
import { BuyerRepository } from './repositories/buyer-repository/BuyerRepository';
import { CollectionAgentRepository } from './repositories/collection-agent-repository/CollectionAgent';
import { PriceSetupRepository } from './repositories/price-setup-repository/PriceSetupRepository';
import { SalesAgentRepository } from './repositories/sales-agent-repository/salesAgent';
import { VendorRepository } from './repositories/vendor-repository/VendorRepository';
import { UnitOfMeasurementRepository } from './repositories/unit-of-measurement-repository/UnitOfMeasurementRepository';
import { UOMGroupRepository } from './repositories/unit-of-measurement-group-repository/UOMGroupRepository';
import { BuyerGroupSetupRepository } from './repositories/buyer-group-setup-repository/BuyerGroupSetupRepository';
import { SalesRegionRepository } from './repositories/sales-region-repository/SalesRegionRepository';
import { ProductGroupDiscountSetupRepository } from './repositories/product-group-discount-setup-repository/ProductGroupDiscountSetupRepository';
import { TaxSetupRepository } from './repositories/tax-setup-repository/TaxSetupRepository';
import { TaxRateMasterRepository } from './repositories/tax-rate-master-repository/TaxRateMasterRepository';
import { ProcurementCodeSetupRepository } from './repositories/procurement-code-setup-repository/ProcurementCodeSetupRepository';
import { ProcurementPostingSetupRepository } from './repositories/procurement-posting-setup-repository/ProcurementPostingSetupRepository';
import { GodownCodeSetupRepository } from './repositories/godown-code-setup-repository/GodownCodeSetupRepository';
import { GlobalSetupsRepository } from './repositories/global-setups-repository/GlobalSetupsRepository';
import { SalesCreditControlsRepository } from './repositories/sales-credit-controls-repository/SalesCreditControlsRepository';
import { StockAdjustmentRepository } from './repositories/stock-adjustment-repository/StockAdjustmentRepository';
import { CountersRepository } from './repositories/counters-repository/CountersRepository';
import { UsersRepository } from './repositories/users-repository/UsersRepository';
import { ProcurementReportRepository } from './repositories/report-setup-repository/ProcurementReportRepository';
import { PrinterGroupRepository } from './repositories/printer-group-repository/PrinterGroupRepository';
import { ProcurementPrintReportRepository } from './repositories/print-report-repository/ProcurementPrintReportRepository';
import { ReceiptSetupRepository } from './repositories/receipt-setup/ReceiptSetupRepository';
import { PurchasePostingSetupRepository } from './repositories/purchase-posting-setup-repository/PurchasePostingSetup';
import { StartingNumberSetupRepository } from './repositories/starting-number-setup-repository/starting-number-setup-repository';
import { SalesPostingSetupRepository } from './repositories/sales-posting-setup-repository/SalesPostingSetup';
import { GodownRepository } from './repositories/godown-repository/GodownRepository';
import { ProductCardMasterCategoryRepositoryService } from './repositories/product-card-master-repository/Product-Card-Master-Category';
import { PurchaseOrderRepository } from './repositories/purchase-order-repository/PurchaseOrderRepository';
import { SaleOrderRepository } from './repositories/sale-order-repository/SaleOrderRepository';
import { PurchaseReturnRepository } from './repositories/purchase-return-repository/PurchaseReturnRepository';
import { CompanyProfileRepository } from './repositories/company-profile-repository/CompanyProfileRepository';
import { SaleReturnRepository } from './repositories/sale-Return-repository/SaleReturnRepository';
import { SaleCollectionsRepository } from './repositories/sale-collections-repository/SaleCollectionsRepository';
import { StockInternalUseRepository } from './repositories/stock-internal-use/StockInternalUseRepository';
import { StockDamageRepository } from './repositories/stock-damage/StockDamageRepository';
import { ProductGroupsRepository } from './repositories/product-groups-repository/ProductGroupsRepository';
import { WeighScaleSetupRepository } from './repositories/weigh-scale-setup-repository/WeighScaleSetupRepository';
import { AccountCodeSetupRepository } from './repositories/finance/account-code-setup-repository/AccountCodeSetupRepository';
import { AccountMasterRepository } from './repositories/finance/account-master-repository/AccountMasterRepository';
import { AccountMasterBalanceRepository } from './repositories/finance/account-master-balance-repository/AccountMasterBalanceRepository';
import { AccountBookSetupRepository } from './repositories/finance/account-book-setup-repository/AccountBookSetupRepository';
import { ReceiptsRepository } from './repositories/finance/receipts-repository/ReceiptsRepository';
import { PaymentsRepository } from './repositories/finance/payments-repository/PaymentsRepository';
import { DebitNotesRepository } from './repositories/finance/debit-notes-repository/DebitNotesRepository';
import { CreditNotesRepository } from './repositories/finance/credit-notes-repository/CreditNotesRepository';
import { JournalVoucherRepository } from './repositories/finance/journal-voucher-repository/JournalVoucherRepository';
import { TransactionViewerRepository } from './repositories/finance/transaction-viewer-repository/TransactionViewerRepository';
import { PocketStyleRepository } from './repositories/pocket-style-repository/PocketStyleRepository';
import { TailorTypeRepository } from './repositories/tailor-type-repository/TailorTypeRepository';
import { ProductCompanyRepository } from './repositories/product-company-repository/ProductCompanyRepository';
import { BridgeServerConfigurationRepository } from './repositories/bridge-server-configuration-repository/BridgeServerConfigurationRepository';

//Global Variables
import { Globals } from '../environments/Globals';
import { TopToolBarOptions } from './services/btnservice/toptoolbar-options';
import { TranslatePipe } from './shared/custom-pipes/translate-pipe/translate.pipe';
import { ConfirmationModalComponent } from './shared/confirmation-dialog/confirmation-dialog.component';
import { MultiTablesNamesServices } from './shared/multi-tables-names/multi-tables-names.service';
import { MultiTablesNamesModalComponent } from './shared/multi-tables-names/multi-tables-names.component';
import { UnitGridPopupService } from './shared/unit-grid-popup/unit-grid-popup.service';
import { UnitGridPopupComponent } from './shared/unit-grid-popup/unit-grid-popup.component';
import { AgGridCheckboxCellComponent } from './shared/ag-grid-checkbox-cell/ag-grid-checkbox-cell.component';
import { AgGridDropdownComponent } from './shared/ag-grid-dropdown/ag-grid-dropdown.component';
import { AddNewButtonSalesTargetComponent } from './shared/add-new-button-sales-target/add-new-button-sales-target.component';
import { GridDeleteButtonComponent } from './shared/grid-delete-button/grid-delete-button.component';
import { TablesNamesRenderer } from './shared/ag-grid-names-popup/agGrid-names-renderer';
import { AgGridNamesAddComponent } from './shared/ag-grid-names-add/ag-grid-names-add.component';
import { GridSaveButtonComponent } from './shared/grid-save-button/grid-save-button.component';
import { AgGridUnitsPopupComponent } from './shared/ag-grid-units-popup/ag-grid-units-popup.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AutoCompleteComponent } from './shared/smartapp-angular';
import { AgGridCheckboxComponent } from './shared/ag-grid-checkbox/ag-grid-checkbox.component';
import { AmountEditorComponent } from './cell-editor-components/amount-editor-component';
import { CurrencyEditorComponent } from './cell-editor-components/currency-editor-component';
import { IntegerEditorComponent } from './cell-editor-components/integer-editor-component';
import { NumericEditorComponent } from './cell-editor-components/numeric-editor-component';
import { PriceEditorComponent } from './cell-editor-components/price-editor-component';
import { QuantityEditorComponent } from './cell-editor-components/quantity-editor-component';
import { ValueFormatter } from './value-formatters/value-formatter';
import { SanitizeValueFormatter } from './value-formatters/sanitize-value-formatter';
import { AgGridButtonRendererComponent } from './shared/ag-grid-button-renderer/button-renderer.component';
import { AgGridUserActionButtonsComponent } from './shared/ag-grid-user-action-buttons/ag-grid-user-action-buttons.component';
import { ProductQuantityInGodownsComponent } from './shared/product-quantity-in-godowns/product-quantity-in-godowns.component';
import { AccountCodeEditorComponent } from './cell-editor-components/account-code-editor-component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { FiscalSpansRepository } from './repositories/fiscal-spans/FiscalSpansRepository';
import { SalesGroupRepository } from './repositories/sales-group-repository/SalesGroupRepository';
import { DropdownRenderComponent } from './shared/dropdown-render-component/dropdown-render-component';
import { P401Component } from './views/error/401.component';
import { DropdownRenderInGivenValuesComponent } from './shared/dropdown-render-in-given-values-component/dropdown-render-in-given-values-component';
import { BtnBarcodeRendererComponent } from './shared/btn-barcode-renderer/btn-barcode-renderer.component';
import { StockBatchSerialInwardsComponent } from './shared/stock-batch-serial-inwards/stock-batch-serial-inwards.component';
import { BtnBarcodeOutwardsRendererComponent } from './shared/btn-barcode-outward-renderer/btn-barcode-outward-renderer.component';
import { StockBatchSerialOutwardsComponent } from './shared/stock-batch-serial-outwards/stock-batch-serial-outwards.component';
import { BtnSaleBarcodeRendererComponent } from './shared/btn-sale-barcode-renderer/btn-sale-barcode-renderer.component';
import { SaleStockBatchSerialInwardsComponent } from './shared/sale-stock-batch-serial-inwards/sale-stock-batch-serial-inwards.component';
import { BtnSaleBarcodeOutwardsRendererComponent } from './shared/btn-sale-barcode-outward-renderer/btn-sale-barcode-outward-renderer.component';
import { SaleStockBatchSerialOutwardsComponent } from './shared/sale-stock-batch-serial-outwards/sale-stock-batch-serial-outwards.component';
import { TestPageComponent } from './views/procurement/test-folder/test-page/test-page.component';
import { PaymentTermRepository } from './repositories/payment-term-repository/PaymentTermRepository';
import { CurrencyRepository } from './repositories/currency-repository/CurrencyRepository';
import { NamingConventionsRepository } from './repositories/naming-conventions-repository/NamingConventionsRepository';
import { InvoicePostingSetupRepository } from './repositories/invoice-posting-setup-repository/InvoicePostingSetup';
import { IncomingPaymentsRepository } from './repositories/finance/incoming-payments-repository/IncomingPaymentsRepository';
import { OutgoingPaymentsRepository } from './repositories/finance/outgoing-payments-repository/OutgoingPaymentsRepository';
import { NgxTypeaheadModule } from 'ngx-typeahead';
import { TaxDropdownRenderComponent } from './shared/tax-dropdown-render-component/tax-dropdown-render-component';
import { InvoiceRepository } from './repositories/finance/invoice-repository/InvoiceRepository';
import { InvoiceCollectionRepository } from './repositories/finance/invoice-collection-repository/InvoiceCollectionRepository';
import { PLBSClassNamesRepository } from './repositories/plbs-class-names-repository/PLBSClassNamesRepository';
import { LoginComponent } from './views/authentication/login/login.component';
import { SharedModule } from './shared/shared.module';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { CommissionSetupRepository } from './repositories/commission-setup-repository/CommissionSetupRepository';

import { ChannelPricesRepository } from './repositories/channel-prices-repository/ChannelPricesRepository';
import { BuyerSMSRepository } from './repositories/procurement/buyer-sms-repository/BuyerSMSRepository';
import { AnalyticGroupsRepository } from './repositories/analytic-groups-repository/AnalyticGroupsRepository';
import { AddOnGroupRepository } from './repositories/add-on-group-repository/AddOnGroupRepository';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptorService } from './views/authentication/authentication-helpers/http-request-interceptor.service';
import { AccountTransferRepository } from './repositories/finance/account-transfer-repository/AccountTransferRepository';
import { AgmCoreModule } from '@agm/core';
import { ProductSizeRepository } from './repositories/product-size-repository/ProductSizeRepository';
import { ProductColorRepository } from './repositories/product-color-repository/ProductColorRepository';

import { LoaderService } from './services/loader/LoaderService';
import { ClientSignupComponent } from './views/authentication/client-signup/client-signup.component';
import { AutoPurchaseOrderRepository } from './repositories/auto-purchase-order-repository/AutoPurchaseOrderRepository';
import { ProductLocationRepository } from './repositories/product-location-repository/ProductLocationRepository';
import { FundsTransferRepository } from './repositories/finance/funds-transfer-repository/FundsTransferRepository';
import { StockBatchInwardRepository } from './repositories/stock-batch-inward-repository/StockBatchInwardRepository';
import { POSStringsRepository } from './repositories/pos-strings-repository/POSStringsRepository';
import { TreeModule } from 'angular-tree-component';

@NgModule({
  declarations: [
    AppComponent,
    P404Component,
    P401Component,
    ConfirmationModalComponent,
    MultiTablesNamesModalComponent,
    UnitGridPopupComponent,
    AgGridCheckboxCellComponent,
    AgGridDropdownComponent,
    AddNewButtonSalesTargetComponent,
    GridDeleteButtonComponent,
    TablesNamesRenderer,
    AgGridNamesAddComponent,
    GridSaveButtonComponent,
    AgGridUnitsPopupComponent,
    AutoCompleteComponent,
    TestPageComponent,
    AgGridCheckboxComponent,
    AmountEditorComponent,
    CurrencyEditorComponent,
    IntegerEditorComponent,
    NumericEditorComponent,
    PriceEditorComponent,
    QuantityEditorComponent,
    AgGridButtonRendererComponent,
    AgGridUserActionButtonsComponent,
    ProductQuantityInGodownsComponent,
    AccountCodeEditorComponent,
    DropdownRenderComponent,
    DropdownRenderInGivenValuesComponent,
    BtnBarcodeRendererComponent,
    StockBatchSerialInwardsComponent,
    BtnBarcodeOutwardsRendererComponent,
    StockBatchSerialOutwardsComponent,
    BtnSaleBarcodeRendererComponent,
    SaleStockBatchSerialInwardsComponent,
    BtnSaleBarcodeOutwardsRendererComponent,
    SaleStockBatchSerialOutwardsComponent,
    TaxDropdownRenderComponent,
    LoginComponent,
    ClientSignupComponent,
    AuthLayoutComponent,
  ],

  entryComponents: [
    AgGridCheckboxComponent,
    ConfirmationModalComponent,
    MultiTablesNamesModalComponent,
    GridDeleteButtonComponent,
    AddNewButtonSalesTargetComponent,
    UnitGridPopupComponent,
    AgGridUnitsPopupComponent,
    TablesNamesRenderer,
    AgGridNamesAddComponent,
    GridSaveButtonComponent,
    AgGridCheckboxCellComponent,
    AgGridDropdownComponent,
    ProductQuantityInGodownsComponent,
    AgGridUserActionButtonsComponent,
    AgGridButtonRendererComponent,
    DropdownRenderComponent,
    DropdownRenderInGivenValuesComponent,
    BtnBarcodeRendererComponent,
    StockBatchSerialInwardsComponent,
    BtnBarcodeOutwardsRendererComponent,
    StockBatchSerialOutwardsComponent,
    BtnSaleBarcodeRendererComponent,
    SaleStockBatchSerialInwardsComponent,
    BtnSaleBarcodeOutwardsRendererComponent,
    SaleStockBatchSerialOutwardsComponent,
    TaxDropdownRenderComponent,
    // BsModalService
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PerfectScrollbarModule,
    BrowserAnimationsModule,
    NgxTypeaheadModule,
    SharedModule,
     TreeModule.forRoot(),  
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      //progressBar: true,
      closeButton: true,
      enableHtml: true,
    }),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    TypeaheadModule.forRoot(),
    AppRoutingModule,
    NgxBarcodeModule,
    ModalModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDvAwW_k2B3e_iyjgluh2q6XXJ1jGDSE3g',
      libraries: ['places'],
      language: 'en',
    }),

    AgGridModule.withComponents([
      AutoCompleteComponent,
      AmountEditorComponent,
      CurrencyEditorComponent,
      IntegerEditorComponent,
      NumericEditorComponent,
      PriceEditorComponent,
      QuantityEditorComponent,
      AccountCodeEditorComponent,
      NgxTypeaheadModule,
    ]),
  ],
  providers: [
    BusinessServices,
    FinanceBusinessService,
    CommonRepository,
    ImplementOperationToolbar,
    TopToolBarOptions,
    LoginRepository,
    BuyerRepository,
    FiscalSpansRepository,
    CollectionAgentRepository,
    POSStringsRepository,
    SalesAgentRepository,
    SalesRegionRepository,
    VendorRepository,
    UnitOfMeasurementRepository,
    ProductLocationRepository,
    ProductGroupDiscountSetupRepository,
    UOMGroupRepository,
    CurrencyRepository,
    NamingConventionsRepository,
    PriceSetupRepository,
    CommissionSetupRepository,
    TaxSetupRepository,
    CompanyProfileRepository,
    TaxRateMasterRepository,
    BuyerGroupSetupRepository,
    ProcurementPostingSetupRepository,
    GodownCodeSetupRepository,
    GlobalSetupsRepository,
    SalesCreditControlsRepository,
    ProcurementCodeSetupRepository,
    PurchasePostingSetupRepository,
    SalesPostingSetupRepository,
    ProductSizeRepository,
    ProductColorRepository,
    SmartAppUtilities,
    TranslateService,
    Globals,
    TranslatePipe,
    GodownRepository,
    ConfirmationDialogServices,
    MultiTablesNamesServices,
    UnitGridPopupService,
    BsModalService,
    StartingNumberSetupRepository,
    ProductCardMasterCategoryRepositoryService,
    PurchaseOrderRepository,
    AutoPurchaseOrderRepository,
    SaleOrderRepository,
    PurchaseReturnRepository,
    SaleReturnRepository,
    SaleCollectionsRepository,
    ValueFormatter,
    SanitizeValueFormatter,
    StockInternalUseRepository,
    StockAdjustmentRepository,
    StockBatchInwardRepository,
    StockDamageRepository,
    UsersRepository,
    ProcurementReportRepository,
    PrinterGroupRepository,
    PocketStyleRepository,
    TailorTypeRepository,
    ProcurementPrintReportRepository,
    ProductGroupsRepository,
    ReceiptSetupRepository,
    WeighScaleSetupRepository,
    AccountCodeSetupRepository,
    AccountMasterRepository,
    PLBSClassNamesRepository,
    AccountMasterBalanceRepository,
    InvoicePostingSetupRepository,
    AccountBookSetupRepository,
    ReceiptsRepository,
    PaymentsRepository,
    PaymentTermRepository,
    DebitNotesRepository,
    CreditNotesRepository,
    JournalVoucherRepository,
    TransactionViewerRepository,
    SalesGroupRepository,
    IncomingPaymentsRepository,
    OutgoingPaymentsRepository,
    FundsTransferRepository,
    InvoiceRepository,
    InvoiceCollectionRepository,
    ChannelPricesRepository,
    BuyerSMSRepository,
    AnalyticGroupsRepository,
    AddOnGroupRepository,
    AccountTransferRepository,
    ProductCompanyRepository,
    CountersRepository,
    BridgeServerConfigurationRepository,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptorService,
      multi: true,
      deps: [Globals, LoaderService],
    },
    //  , {
    //      provide: APP_INITIALIZER,
    //      useFactory: setupTranslateFactory,
    //      deps: [
    //          TranslateService,
    //          Globals
    //      ],
    //      multi: true
    //  }
  ],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class AppModule {}
